<template>
  <div>
    <v-stepper v-model="currentStep">
      <v-stepper-header>
        <v-stepper-step :complete="currentStep > 1" step="1">
          Login
        </v-stepper-step>
        <v-stepper-step step="2">
          Accept Invitation
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <login-form @success="currentStep = 2"></login-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <h3>
            accept invitation from {{companyName}} ?
          </h3>
          <v-btn color="primary" class="mx-0 px-0" @click="acceptInvitation">Accept</v-btn>
          <v-btn flat class="accent--text"
                 @click="declineInvitation">Refuse</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import API from '@/api';
import * as types from '@/store/mutationTypes';
import { mapGetters } from 'vuex';
import LoginForm from '@/components/LoginForm';

export default {
  props: {
    companyId: {
      type: Number,
    },
  },
  components: {
    LoginForm,
  },
  data() {
    return {
      currentStep: 1,
      companyName: '', // TODO
    };
  },
  computed: {
    ...mapGetters('applications', [
      'signedIn',
    ]),
    token() {
      return this.$route.params.token;
    },
  },
  methods: {
    async acceptInvitation() {
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        await API.dispatchers.acceptInvitation(this.token);
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Invitation accepted',
          timeout: 7000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async declineInvitation() {
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        await API.dispatchers.refuseInvitation(this.token);
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Invitation canceled',
          timeout: 7000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
  },
  created() {
    if (this.signedIn) {
      this.currentStep = 2;
    }
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/User/DispatchInvite.vue